import MediaConfig from "./MediaConfig";

export default class MediaService {
	static uploadImage(file, path, type, callback) {
		return new Promise(async (resolve, reject) => {
			try {
				let response = await MediaConfig.FirebaseConnector.uploadFile(
					file,
					path,
					type,
					callback
				);
				resolve(response);
			} catch (e) {
				reject(e);
			}
		});
	}
	static deleteImage(path, callback) {
		return new Promise(async (resolve, reject) => {
			try {
				let response = await MediaConfig.FirebaseConnector.deleteImage(
					path,
					callback
				);
				resolve(response);
			} catch (e) {
				reject(e);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/media/MediaService.js